import InputAdornment from '@material-ui/core/InputAdornment';
import { get } from 'lodash';
import React, { useState } from 'react';
import { GenericFormFields } from 'skyone-lib/lib/GenericForm/interfaces';
import { Grid } from '@material-ui/core';
import MaskedInput from '../MaskedInput';

const GenericMaskedInputField: React.FC<GenericFormFields> = ({
  fields,
  item,
  values,
  setFieldValue,
  changeField,
  errors,
}) => {
  const getInitialValue = () => {
    if (fields?.[item?.stateKey]) return fields[item?.stateKey];
    if (values?.[item?.stateKey]) return values[item?.stateKey];
    return '';
  };

  const [value, setValue] = useState(getInitialValue);

  const field = get(fields, item?.stateKey, null);

  React.useEffect(() => {
    if (field) setValue(field);
    else setValue('');
  }, [fields, field]);

  const endAdorn = () => {
    if (item?.tooltip) {
      return {
        endAdornment: (
          <InputAdornment position="end">{item?.tooltip}</InputAdornment>
        ),
      };
    }

    return undefined;
  };

  const [mask, setMask] = useState(
    item?.masks ? item?.masks[0].mask : item?.mask || ''
  );

  const currentMask = (v: number) => {
    if (item?.masks) {
      setMask(item?.masks.find(m => v <= m.letterCount)?.mask || '');
    } else {
      setMask(item?.mask || '');
    }
  };

  const getMask = () => {
    if (item?.validatePhoneOrEmailMask) {
      if (
        value.length > 3 &&
        value
          .replace(/[^A-Z0-9]/gi, '')
          .slice(0, 3)
          .match(/^\d+$/)
      )
        return '+99 (99) 99999-9999';
      return '';
    }
    return mask;
  };

  return (
    <Grid data-testid={'autosky-genericmaskedinputfield'}>
      <MaskedInput
        id={item?.idHtml || item?.stateKey}
        key={item?.stateKey}
        mask={getMask()}
        autoFocus
        maskChar=""
        value={value}
        onChange={e => {
          setValue(e.target.value);
          currentMask(e.target.value.length);

          if (item?.validateOnChange) {
            if (setFieldValue) setFieldValue(item?.stateKey, e.target.value);
            setValue(e.target.value);
          }
        }}
        onBlur={e => {
          if (setFieldValue) setFieldValue(item?.stateKey, e.target.value);
          if (changeField)
            changeField({
              key: item?.stateKey,
              value: Object(item)?.hasOwnProperty('id')
                ? { id: item?.id, value: e.target.value }
                : e.target.value,
            });
        }}
        variant={item?.variant || 'outlined'}
        label={item?.label}
        error={
          !!get(errors, item?.stateKey, null) ||
          !!get(errors, item?.error as string, null)
        }
        helperText={
          get(errors, item?.stateKey, null) ||
          get(errors, item?.error as string, null)
        }
        disabled={item?.disabled}
        InputProps={endAdorn()}
      />
    </Grid>
  );
};

export default GenericMaskedInputField;
